import { Heading, Text, Box } from '@chakra-ui/react';
import { Trans, useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { SubmitFormBtn } from '../../../Buttons/SubmitFormBtn';

export const InviteSuccessSended = ({ goBack }: { goBack: VoidFunction }) => {
  const { t } = useTranslation();
  const { state } = useLocation();
  const { userName } = state;

  return (
    <Box maxW='md'>
      <Heading fontSize='22px' fontWeight={500} color='brand.cyan'>
        {t('member.invite.success.heading', { userName })}
      </Heading>

      <Text mt={4}>
        <Trans i18nKey='member.invite.success.text' />
      </Text>

      <SubmitFormBtn mt={10} minH={'58px'} onClick={goBack}>
        {t('ok')}
      </SubmitFormBtn>
    </Box>
  );
};
